/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import AppRoot from "components/AppRoot";
import ReactDOM from "react-dom";
import "stylesheets/application.scss";
import * as ActiveStorage from "@rails/activestorage";
import "components/shared/WebComponents";
import {
  injectPrivacyScript,
  registerPrivacyEventListeners,
} from "privacy/PrivacyManager";
import { registerUnhandledRejectionListeners } from "utilities/noticeUnhandledRejection";

registerPrivacyEventListeners();
registerUnhandledRejectionListeners();
ActiveStorage.start();

Promise.all([injectPrivacyScript()])
  .then(() => {
    const root = document.getElementById("root");
    if (root && root.hasChildNodes()) {
      ReactDOM.hydrate(<AppRoot />, root);
    } else {
      ReactDOM.render(<AppRoot />, root);
    }
  })
  .catch((error) => {
    console.error("Error initializing the app:", error);
    newrelic.noticeError(error);
  });
